module.exports = __webpack_public_path__ + "media/components/country-flag/static/ax-9cd09d048bc678b5ae160ced7fec3d03.svg";